/**
 *
 * @module platform
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef Platform
 * @type {Object}
 *
 * @property {String} appletv
 * @property {String} chromecast
 * @property {String} netcast
 * @property {String} panasonictv
 * @property {String} orsay
 * @property {String} sonybravia
 * @property {String} trilithium
 * @property {String} tivo
 * @property {String} tizen
 * @property {String} vizio
 * @property {String} webos
 *
 */

/**
 *
 * @enum
 * @type {Platform}
 * @desc Enum for the possible platform values in the ConfigurationClientConfiguration
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    appletv: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    chromecast: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    netcast: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    panasonictv: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    orsay: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    sonybravia: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    trilithium: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    tivo: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    tizen: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    vizio: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    webos: null
});



// WEBPACK FOOTER //
// ./src/services/configuration/platform.js